import ErrorBoundary from "app/ErrorBoundary/ErrorBoundary";
import React, { lazy, Suspense } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import "./MainEventsLayoutDesktop.scss";
import "./MainEventsLayoutTablet.scss";
const BetDrawerScreen: React.LazyExoticComponent<any> = lazy(
  () => import("../../screens/BetDrawerScreen/BetDrawerScreen")
);
type Props = {
  showNotificationDisplay: boolean;
  match: any;
};

const MainEventsLayoutDesktopHOC = (WrappedComponent: any) => {
  return function MainEventsLayoutDesktop(props: Props): React.JSX.Element {
    const { showNotificationDisplay, ...rest } = props;
    // if events check params for selected tab
    return (
      <div
        className={`events-screen ${
          showNotificationDisplay ? "show-notifications" : ""
        }`}
        style={{
          paddingTop: showNotificationDisplay ? "67px" : "0px",
        }}
      >
        <div className="events-screen__wrapper">
          <div className="events-screen__col events-screen__col-8">
            <ErrorBoundary>
              <WrappedComponent {...rest} />
            </ErrorBoundary>
          </div>
          <div className="events-screen__sidebar events-screen__col events-screen__col-4">
            <ErrorBoundary>
              <Suspense fallback={<div className="fallback">loading...</div>}>
                <BetDrawerScreen />
              </Suspense>
            </ErrorBoundary>
          </div>
        </div>
      </div>
    );
  };
};

const mapStateToProps = state => ({
  showNotificationDisplay: state.notificationListModel.showNotificationDisplay,
});

const composedMainEventsLayoutDesktopHOC: any = compose(
  connect(mapStateToProps, null),
  MainEventsLayoutDesktopHOC
);
export default composedMainEventsLayoutDesktopHOC;
